import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { rpc } from "../api/rpc";
import { authInfoQueryKey } from "./AuthProvider";

/**
 * `auth.delete` rotates the user's signing secret, so every session everywhere
 * is invalidated (note 01 §4.4). The local cache is cleared either way — if the
 * call fails the session is unusable to us regardless.
 */
export function useSignOut(): () => Promise<void> {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useCallback(async () => {
    try {
      await rpc("auth.delete");
    } finally {
      queryClient.setQueryData(authInfoQueryKey, null);
      queryClient.clear();
      void navigate("/", { replace: true });
    }
  }, [navigate, queryClient]);
}
